import React from "react"
import Header from "./header"
import Image from "./image"
import Subtitle from "./subtitle"
import GrayLine from "./gray-line"

const Playlist = ({ attributes, images, title, display_name, editing }) => {
  return (
    <table
      data-testid="playlist"
      {...attributes}
      style={{ borderCollapse: "collapse", padding: "0px" }}
    >
      <tbody>
        <tr style={{ height: "80px" }}>
          <Image images={images} editing={editing} />
          <td
            style={{
              backgroundColor: "black",
              background: "linear-gradient(gray, 30%, black)",
              width: "250px",
              paddingLeft: "12px",
              paddingRight: "12px",
              paddingBottom: "0px",
              height: "80px"
            }}
          >
            <Header title={title} />
            <Subtitle subtitle={display_name} />
            <GrayLine />
          </td>
        </tr>
      </tbody>
    </table>
  )
}
export default Playlist
